<template>
  <div class="modalTable">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button @click="clearRadioRowEevnt">取消选中</el-button>
        <el-button @click="getRadioEvent1">获取选中</el-button>
        <el-button @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="80%"
      auto-resize
      border
      class="radio-table"
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="300"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物类型"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isQuote"
          :formatter="billingTypeStatus"
          title="是否允许报价"
          min-width="200"
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isQuote" clearable placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="weight" title="货物数量" min-width="200" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.weight"
            placeholder="请输入内容"
            type="number"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="price" title="运费单价" min-width="200" />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                placeholder="下限"
                type="number"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                placeholder="上限"
                type="number"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="coalNumber" title="车数要求" min-width="200" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { SupplyManagement } from "@/api/orderform";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      getdata: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isOftenOrder: 1
      },
      Pagingconf: [],
      tableData: [],
      options2: [
        {
          value: "0",
          label: "不允许"
        },
        {
          value: "1",
          label: "允许"
        }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {},
  methods: {
    //查询常发货源
    shipmentlist() {
      SupplyManagement(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },
    //是否允许报价
    billingTypeStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "不允许";
        case "1":
          return "允许";
        default:
          break;
      }
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    //获取选中
    getRadioEvent1() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      if (this.getdata) {
        this.$emit("event5", this.getdata);
      } else {
        this.$message({ message: "请选择一个常发货源", type: "warning" });
      }
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
